import List from '../Pattern.List.i18n';
import Detail from '../Pattern.Detail.i18n';
import Language from './language';

export default {
  components: { List, Detail, Language },
  data: () => ({ base: false, list: false, detail: false }),
  methods: {
    refresh() {
      console.log('this.$refs.list', this.$refs.list)
      if(this.$refs.list) { (this.$refs.list.$children || []).forEach(el => el.refresh()); }
    },
    select({ id, tag }) {
      if(!id) { this.base = this.list = !(this.detail = false); }
      else { this.detail = !(this.list = false); }
    }
  },
  created: function() {   console.log('pattern.list.vue', 'created'); },
  destroyed: function() { console.log('pattern.list.vue', 'destroyed'); },
  mounted: function() { console.log('pattern.list.vue', 'mounted'); this.select(this.$route.params); },
  watch: {
    '$route' (to, from) {
      console.log('pattern.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
}
